import { alpha, buttonClasses, Components, Theme } from '@mui/material';

export const getMuiButton = (theme: Theme): Components['MuiButton'] => ({
  defaultProps: {
    variant: 'contained',
    disableRipple: true,
  },

  styleOverrides: {
    root: {
      textTransform: 'inherit',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      transition: 'none',

      '& svg': {
        color: 'inherit',
      },

      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            background: `linear-gradient(148.43deg, ${theme.palette.primary.light} 16.94%, ${theme.palette.primary.main} 43.58%, ${theme.palette.primary.dark} 79.11%)`,
            color: theme.palette.primary.contrastText,

            '&:hover, &:active, &:focus': {
              background: `linear-gradient(148.43deg, ${theme.palette.primary.dark} 16.94%, ${theme.palette.primary.main} 43.58%, ${theme.palette.primary.light} 79.11%)`,
            },
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,

            '&:hover, &:active, &:focus': {
              background: theme.palette.primary.light,
            },
          },
        },
      ],
    },

    sizeSmall: {
      height: 28,
      minHeight: 28,
      minWidth: 50,
      padding: theme.spacing(0, 3),
      borderRadius: 8,
      fontSize: 12,
      lineHeight: 1.12,
      fontWeight: 400,
    },

    sizeMedium: {
      height: 36,
      minHeight: 36,
      padding: theme.spacing(0, 7),
      borderRadius: 8,
      fontSize: 16,
      lineHeight: 1.2,
      fontWeight: 600,
    },

    sizeLarge: {
      height: 48,
      minHeight: 48,
      padding: theme.spacing(0, 7),
      borderRadius: 12,
      fontSize: 16,
      lineHeight: 1.2,
      fontWeight: 600,
    },

    contained: {
      '&:hover': {
        boxShadow: 'none',
      },

      [`&.${buttonClasses.disabled}`]: {
        background: alpha(theme.palette.primary.main, 0.4),
        color: theme.palette.primary.contrastText,
      },
    },
  },
});
